import {Dispatch} from 'redux';
import {
  TIMELINE_CMD_BY_EVENT_AND_LAST_ID_GET_INVALIDATE,
  TIMELINE_CMD_BY_EVENT_AND_LAST_ID_GET_REQUEST,
  TIMELINE_CMD_BY_EVENT_AND_LAST_ID_GET_RESPONSE,
} from '../../actionTypes';
import {
  TimelineCmdByEventAndIdGetInvalidateAction,
  TimelineCmdByEventAndIdGetRequestAction,
  TimelineCmdByEventAndIdGetResponseAction,
} from '../types';
import {TimelineUpdateCommand} from '../../../utils/types';
import standardizeError from '../../../utils/standardizeError';
import {beTimelineUpdateCommandToTimelineUpdateCommand} from '../../../API/utils';
import timelineUpdateCommandsByEventAndId from '../../../API/timelineUpdateCommands';

/**
 * Action creator for the get request of the timeline update commands
 * @param eventId sport event id
 * @param id Id of the last update command
 */
const getTimelineCmdByEventAndIdGetRequest = (eventId: string, id?: string): TimelineCmdByEventAndIdGetRequestAction => ({
  type: TIMELINE_CMD_BY_EVENT_AND_LAST_ID_GET_REQUEST,
  payload: {
    eventId,
    id,
  },
});

/**
 * Action creator for the get response of the timeline update commands
 * @param eventId
 * @param commands
 */
const getTimelineCmdByEventAndIdGetResponse = (eventId: string, commands: TimelineUpdateCommand[]): TimelineCmdByEventAndIdGetResponseAction => ({
  type: TIMELINE_CMD_BY_EVENT_AND_LAST_ID_GET_RESPONSE,
  payload: {
    eventId,
    commands,
  },
});

/**
 * Action creator for the get invalidation of the timeline update commands
 * @param error
 */
const getTimelineCmdByEventAndIdGetInvalidate = (error: Error): TimelineCmdByEventAndIdGetInvalidateAction => ({
  type: TIMELINE_CMD_BY_EVENT_AND_LAST_ID_GET_INVALIDATE,
  error: standardizeError(error),
});

/**
 * Thunk managing the retrieval of new timeline update commands for the given sport event and
 * optionally the last received command id
 * @param eventId sport event id
 * @param commandId Id of the last update command
 */
const getTimelineCmdByEventAndId = (eventId: string, commandId?: string) => (dispatch: Dispatch): Promise<any> => {
  dispatch(getTimelineCmdByEventAndIdGetRequest(eventId, commandId));

  return timelineUpdateCommandsByEventAndId(eventId, commandId)
    .then((results) => {
      const commands = results.map(beTimelineUpdateCommandToTimelineUpdateCommand);
      // the `null` updates are the one without evenTag, and here we filter them away from the array
      return <TimelineUpdateCommand[]>commands.filter((u) => u !== null);
    })
    .then((cmds: TimelineUpdateCommand[]) => dispatch(getTimelineCmdByEventAndIdGetResponse(eventId, cmds)))
    .catch((error: Error) => dispatch(getTimelineCmdByEventAndIdGetInvalidate(error)));
};

export default getTimelineCmdByEventAndId;
